<template>
  <div class="header" id="header">
    <a href="javascript:void(0)" class="logo">
      <img src="@img/logo.png" alt="">
      <span>Учет и мониторинг земель<br>Воронежской области</span>
    </a>
    <a href="javascript:void(0)" class="logo logo-mobile">
      <img src="@img/logo.png" alt="">
      <span>УМЗ<br>Воронежской области</span>
    </a>
    <div class="header-control" v-if="isAuthorized">
      <div class="analit" v-if="permisAnalit">
        <span class="analit-link">Аналитика</span>
        <div class="analit-block">
          <div class="analit-wrap">
            <span @click="showAnalytic(true, 'area')">Аналитика площадей</span>
            <span @click="showAnalytic(true, 'right')">Аналитика прав</span>
            <span @click="showAnalytic(true, 'tlu')">Аналитика угодий</span>
            <a :href="this.$store.getters.value('analitHost')" target="_blank">Подсистема аналитики</a>
          </div>
        </div>
      </div>
      <div class="login-functional">
        <span>{{ userEmail }}</span>
        <button class="btn-personal">
          <img src="@img/personal.svg" alt="">
        </button>
        <div class="logout">
          <div @click="logoutSystem()" class="logout-wrap">
            <span>Выйти</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PopupVue from './PopupVue.vue'
export default {
  name: 'header-component',
  components: {
    PopupVue
  },
  computed: {
    permisAnalit () {
      return this.checkHavePermissionMix('view_analytic')
    },
    isAuthorized () {
      return this.$store.getters.value('isAuthorized')
    },
    userEmail () {
      return this.$store.getters.value('email')
    }
  },
  methods: {
    redirect () {
      if (this.isAuthorized) {
        this.$router.push('/')
      }
    },
    showAnalytic (val, type) {
      let url = this.$store.getters.value('analitHost')
      if (type === 'area') {
        url += '/public/dashboard/cbab1843-e4b5-4f62-b63c-a86f48b2a729'
      } else if (type === 'right') {
        url += '/public/dashboard/da5f53f9-2bf4-42df-a61a-3d1e3fd9e8c8'
      } else if (type === 'tlu') {
        url += '/public/dashboard/2803bca9-61de-4d91-978b-66b8f39c6d12'
      }
      this.$store.dispatch('SET_VALUE', {key: 'showAnal', value: {show: true, url: url}})
    },
    logoutSystem () {
      this.$store.dispatch('SET_VALUE', {key: 'isAuthorized', value: false})
      this.clearCookies()
      this.$router.go('/login')
      this.$apolloProvider.defaultClient.cache.reset()
    }
  }
}
</script>

<style lang="scss">
.header {
  background-color: #11121A;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 50px;
  @media screen and (max-width: 768px){
    width: 100%;
    padding: 15px 15px;
    display: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 70px;
    z-index: 9;
  }
  .logo {
    @media screen and (max-width: 768px){
      display: none;
    }
    cursor: pointer;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
      font-size: 13px;
      font-weight: 700;
      color: #fff;
    }
  }
  .logo-mobile{
    display: none;
    @media screen and (max-width: 768px){
      display: flex;
    }
  }
  &-control {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 14px;
    .btn-personal {
      width: 25px;
      height: 25px;
      margin-left: 10px;
      background: none;
      border-radius: 100%;
      transition: .3s;
      img {
        margin-top: 2px;
      }
    }
  }
}
.analit {
  @media screen and (max-width: 768px){
    display: none;
  }
  position: relative;
  cursor: pointer;
  &-link {
    margin-right: 40px;
    padding: 7px 10px;
    color: #fff;
  }
  &-block {
    position: absolute;
    padding-top: 41px;
    top: 40px;
    left: 0;
    opacity: 0;
    visibility: hidden;
    z-index: 3;
    transition: .3s;
  }
  &-wrap {
    padding: 15px;
    background-color: #fff;
    border-radius: 8px;
    color: #4E53E7;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
    span,
    a {
      display: block;
      display: inline-block;
      margin-bottom: 7px;
      color: #11121A;
      white-space: nowrap;
      transition: .3s;
      &:hover {
        color: #4E53E7;
      }
    }
  }
  &:hover {
    .analit-block {
      top: 0;
      opacity: 1;
      visibility: visible;
    }
  }
}

.login-functional {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  .logout {
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 35px;
    opacity: 0;
    visibility: hidden;
    z-index: 3;
    transition: .3s;
    @media screen and (max-width: 768px){
      top:35px;
      padding-top: 0;
    }
    &-wrap {
      padding: 10px 20px;
      background-color: #fff;
      color: #000;
      border-radius: 8px;
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
      transition: .3s;
      &:hover {
        color: #4E53E7;
      }
    }
  }
  span {
    @media screen and (max-width: 768px){
      display: none;
    }
  }
  &:hover {
    .btn-personal {
      background-color: #4E53E7;
    }
    .logout {
      opacity: 1;
      visibility: visible;
      span {
        @media screen and (max-width: 768px){
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderVue.vue